var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.messages.length)?_c('div',{staticClass:"alertes-extrapolation"},_vm._l((_vm.messages),function(m,i){return _c('div',{key:i,staticClass:"bilan-alerte",class:{ 'bilan-alerte--forte': m.fort }},[(m.fort)?_c('span',[_vm._v("⚠ ")]):_vm._e(),_vm._v(_vm._s(m.texte)+" ")])}),0):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }